


let language = {

    CARD_COUPON_CODE: "优惠码:",
    CARD_REDEEM: "兑换",
    CARD_ONLY: "每个订单最多使用",
    CARD_COUPON_ALLOWED_PER_ORDER: "张",
    CARD_COUPON_CODE_APPLIED: "优惠券已成功申请。"
}

export { language }